import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaginacaoFornecedor } from '../page/fornecedor/paginacaoFornecedor';
import { Fornecedor } from '../page/fornecedor/fornecedor';

@Injectable({
  providedIn: 'root'
})
export class FornecedorService {

  apiURL: string = environment.apiBaseUrl + 'fornecedor';

  constructor(private http: HttpClient) { }

  save(fornecedor: Fornecedor): Observable<Fornecedor> {
    return this.http.post<Fornecedor>(this.apiURL, fornecedor);
  }

  list(page: number, size: number): Observable<PaginacaoFornecedor> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }

  update(fornecedor: Fornecedor): Observable<any> {
    return this.http.put<Fornecedor>(`${this.apiURL}/${fornecedor.id}`, fornecedor);
  }

  findFornecedorById(id: number): Observable<Fornecedor> {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }

  findClientByIdActive(id: number): Observable<Fornecedor> {
    return this.http.get<any>(`${this.apiURL}/active/${id}`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }

  findFornecedores(page: number, size: number, tipoFiltro: string, parametroConsulta: string): Observable<PaginacaoFornecedor> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString()).set('parametroConsulta', parametroConsulta).set('tipoFiltro', tipoFiltro);
    return this.http.get<any>(`${this.apiURL}/consulta?${params.toString()}`);
  }

    listarFornecedor(): Observable<any>{
    return this.http.get<any>(`${this.apiURL}/listarFornecedor`);
  }

}